<template>
    <div class="review-container">
        <div class="content-container">
            <info-modal
                ref="infoModal"
                :msg="infoMsg"
                @ok-submit="closeupdatedStauts"
            />

            <liff-error-modal
                ref="errorModal"
                :msg="errorMsg"
            />

            <info-modal-display-object
                ref="overlapDisplay"
                :groupOverlap="errorOverlap"
            />

            <div class="head-content">
                <div
                    @click="backToTableList"
                    class="back-button">
                    <v-icon
                        color="primary"
                        size="24">
                    arrow_back_ios
                    </v-icon>
                    <span color="primary">{{ $vuetify.lang.t('$vuetify.liffOvertimeRequest.back') }}</span>
                </div>
                <div>
                    {{ `${$vuetify.lang.t('$vuetify.liffOvertimeRequest.totalInquiry')}: ${requestForm.length}` }}
                </div>
            </div>

            <overtime-request-form
                class="mt-4 data-container"
                v-for="(item, index) in requestForm"
                :title="`${title} #${index + 1}`"
                :key="index"
                :value="item"
                :isReviewAction="true"
            />

        </div>
        <div class="footer-container">
            <v-btn
                color="primary"
                outlined
                width="40%"
                @click="updateStatus('REJ')"
            >{{ $vuetify.lang.t('$vuetify.liff.reject') }}</v-btn>
            <v-btn
                color="primary"
                width="40%"
                @click="updateStatus('APV')"
            >{{ $vuetify.lang.t('$vuetify.liff.approve') }}</v-btn>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import OvertimeRequestForm from '@/components/liff/OvertimeRequestForm'
import InfoModal from '@/components/modal/InfoModal'
import InfoModalDisplayObject from '@/components/modal/InfoModalDisplayObject'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
export default {
    name: 'OvertimeReviewDetail',
    props: {
        requestNo: {
            type: String,
            default: ''
        },

        lineId: {
            type: String,
            default: ''
        }
    },

    components: {
        OvertimeRequestForm,
        InfoModal,
        LiffErrorModal,
        InfoModalDisplayObject
    },

    data () {
        return {
            requestForm: [],
            infoMsg: '',
            errorOverlap: {},
            errorMsg: ''
        }
    },

    computed: {
        title () {
            return this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.formTitle')
        }
    },

    methods: {
        async getOTDetailInfo () {
            this.$store.dispatch('setLoading', true)
            const getDetailUrl = `${process.env.VUE_APP_BACKEND}/overtime-detail-line?lineId=${this.lineId}&requestNo=${this.requestNo}`
            const res = await axios.get(getDetailUrl)
            if (res && res.data && res.data.status === 'ok') {
                const otRequestList = res.data.data.otRequestData
                this.transformData(otRequestList)
            }
            this.$store.dispatch('setLoading', false)
        },

        transformData (otRequestList) {
            for (let i = 0; i < otRequestList.length; i++) {
                // example data periodDate: "04/05/64 - 06/05/64 (3d)"
                const [periodDate] = otRequestList[i].periodDate.split('(')
                const [startDateDisplay, endDateDisplay] = periodDate.split(' - ')
                const startDate = this.convertDateThaiDisplayToDateForm(startDateDisplay)
                const endDate = this.convertDateThaiDisplayToDateForm(endDateDisplay)

                // example data periodTime: "19:00 - 20:00"
                const [startTime, endTime] = otRequestList[i].periodTime.split(' - ')
                const startTimeInMinutesUnit = this.$util.timeStringToMinute(startTime)
                const endTimeInMinutesUnit = this.$util.timeStringToMinute(endTime)

                let otTimeInMinutesUnit = endTimeInMinutesUnit - startTimeInMinutesUnit

                if (otTimeInMinutesUnit < 0) {
                    // 24 * 60 mean minute in one day in case ot is overnight
                    otTimeInMinutesUnit = otTimeInMinutesUnit + (24 * 60)
                }

                const otTime = this.convertMinuteToTime(otTimeInMinutesUnit)
                this.requestForm.push({
                    startDate: startDate,
                    endDate: endDate,
                    description: otRequestList[i].description,
                    startTime: startTime,
                    otTime: otTime
                })
            }
        },

        convertDateThaiDisplayToDateForm (dateDisplay) {
            const [date, month, yearBudda] = dateDisplay.split('/')
            // budda different with chris 543
            const yearInChris = parseInt(`25${yearBudda}`) - 543
            return `${yearInChris}-${month}-${date}`
        },

        convertMinuteToTime (totalMinutes) {
            const hours = totalMinutes / 60
            const minutes = totalMinutes % 60
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
        },

        backToTableList () {
            this.$emit('back-button')
        },

        closeupdatedStauts () {
            this.$emit('updated-status')
        },

        async updateStatus (status) {
            this.$store.dispatch('setLoading', true)
            const res = await axios.put(
                `${process.env.VUE_APP_BACKEND}/overtime-review-line/approval`,
                {
                    lineId: this.lineId,
                    status: status,
                    requestNo: this.requestNo
                }
            )
            if (res && res.data && res.data.status === 'ok') {
                this.$refs.infoModal.dialog = true
                this.infoMsg = res.data.msg
            } else if (res && res.data && res.data.status === 'error_overlap') {
                this.$refs.overlapDisplay.dialog = true
                this.errorOverlap = res.data.errors
            } else if (res && res.data && res.data.status === 'error') {
                this.$refs.errorModal.dialog = true
                this.errorMsg = res.data.msg
            }

            this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        await this.getOTDetailInfo()
    }
}
</script>

<style lang="scss" scoped>
.review-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content-container {
        overflow: scroll;
        .head-content {
            color: #D76436;
            padding: 1rem 2rem 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .data-container {
            background: #ffffff;
            color: #6c6c6c;
            margin: 2rem;
            font-size: 14px;
            font-weight: normal;
        }
    }

    .footer-container {
        bottom: 0;
        padding: 10px 0px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        background-color: white;
    }
}

</style>
